import { PhoneticSimilarPhoneBookEntries } from 'src/models/phoneCall';

import { Callback } from 'src/util/query/models/Callback';

import { SetThePhoneticSimilarPhoneBookEntriesPayload } from '../interfaces';

export class GetThePhoneticSimilarPhoneBookEntriesQueryCallback extends Callback<PhoneticSimilarPhoneBookEntries> {
	public constructor(
		private readonly setPhoneticSimilarPhoneBookEntries: (
			payload: SetThePhoneticSimilarPhoneBookEntriesPayload
		) => void
	) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: PhoneticSimilarPhoneBookEntries): void => {
		this.setPhoneticSimilarPhoneBookEntries({
			phoneticSimilarPhoneBookEntries: successResponse,
		});
	};
}
